var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLocked)?_c('div',[_c('span',{staticClass:"label label-danger"},[_vm._v(" "+_vm._s(_vm.$i18n.t('Locked by'))+": "+_vm._s(_vm.lockUser)+" - "+_vm._s(_vm._f("date")(_vm.lockTime))+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }